import { useEffect, useRef, useState } from "react";

// Counts down from `ms` of no scans / taps; calls onIdle once, returns seconds remaining.
export const useIdleTimer = (enabled, ms, onIdle) => {
  const last = useRef(Date.now());
  const fired = useRef(false);
  const cb = useRef(onIdle);
  const [remaining, setRemaining] = useState(ms);
  cb.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;
    last.current = Date.now();
    fired.current = false;
    setRemaining(ms);
    const touch = () => { last.current = Date.now(); fired.current = false; };
    const tick = () => {
      const left = ms - (Date.now() - last.current);
      setRemaining(Math.max(0, left));
      if (left <= 0 && !fired.current) { fired.current = true; cb.current(); }
    };
    window.addEventListener("keydown", touch, true);
    window.addEventListener("pointerdown", touch, true);
    const t = setInterval(tick, 1000);
    return () => {
      window.removeEventListener("keydown", touch, true);
      window.removeEventListener("pointerdown", touch, true);
      clearInterval(t);
    };
  }, [enabled, ms]);

  return remaining;
};
